import { Box, Stack } from '@mui/material'
import type { TDraftReviewSong } from '@modules/types'
import { SongsListFooter } from '../SongsListFooter'
import { SONGS_LIST_STRINGS } from '../strings'
import { SongItemApproval } from './SongItemApproval'
import { usePublisherApproval } from './usePublisherApproval'
import type { TPublisherApprovalRequestShowProps } from '../types'

export const PublisherApprovalRequest = ({
  requestId,
  selectedRequest,
  initialLoading,
  enums,
  apiUrl,
  onDrawerClose,
  onReviewSuccess,
  isRequestSubmitted,
}: TPublisherApprovalRequestShowProps) => {
  const songs = selectedRequest.songs || []
  const distributionMethod = selectedRequest.clientRequest?.distributionMethod || 0
  const { draftReview } = selectedRequest

  const {
    feeQuotedPriceControl,
    handleApproveSong,
    handleRejectSong,
    handleChangeStatus,
    isUpdatingSongStatus,
    processingSongId,
    processingAction,
    validationErrors,
    isSendingReview,
    handleSendReview,
    songsToSubmit,
  } = usePublisherApproval({
    requestId,
    selectedRequest,
    apiUrl,
    onDrawerClose,
    onReviewSuccess,
  })

  return (
    <Box display="flex" flexDirection="column" flex={1} sx={{ bgcolor: 'background.paper' }}>
      <Box flex={1} sx={{ overflowY: 'auto', bgcolor: 'background.paper' }}>
        <Stack spacing={0.5}>
          {songs.map((song, index) => {
            const draftReviewSongs =
              (draftReview?.songs as Array<{ songId: number }> | undefined) || []
            const draftReviewSong =
              (draftReviewSongs.find(ds => ds.songId === song.id) as
                | TDraftReviewSong
                | undefined) || ({} as TDraftReviewSong)
            const digitalCounterOfferFeeError =
              validationErrors[`song_${index}_digital_counter_offer_fee`]?.[0]
            const printCounterOfferFeeError =
              validationErrors[`song_${index}_print_counter_offer_fee`]?.[0]

            return (
              <SongItemApproval
                key={song.id}
                song={song}
                onApprove={songId => handleApproveSong(songId)}
                onReject={(songId, reason) => handleRejectSong(songId, reason)}
                isLoading={isUpdatingSongStatus}
                initialLoading={initialLoading}
                processingSongId={processingSongId}
                processingAction={processingAction}
                draftReviewSong={draftReviewSong}
                distributionMethod={distributionMethod}
                enums={enums}
                onChangeStatus={handleChangeStatus}
                digitalCounterOfferFeeValidationError={digitalCounterOfferFeeError}
                printCounterOfferFeeValidationError={printCounterOfferFeeError}
                feeQuotedPriceControl={feeQuotedPriceControl}
              />
            )
          })}
        </Stack>
      </Box>
      <SongsListFooter
        onSendReview={handleSendReview}
        isSendingReview={isSendingReview}
        isLoading={isUpdatingSongStatus}
        initialLoading={initialLoading}
        isRequestSubmitted={isRequestSubmitted}
        songs={songsToSubmit}
      />
    </Box>
  )
}
